import React, { useContext } from "react";
import Select from "../../ui/Select/Select";
import GlobalsContext from "../../context/GlobalsContext";

const SlotSelect = props => {
  const globalsContext = useContext(GlobalsContext);

  return <Select {...props} options={globalsContext.rb_slot_names} />;
};

export default SlotSelect;
